import type { FilterOptionItem } from '@odo/shared-ui';

export type FoldMode = 'unfolded' | 'folded';

export const DEFAULT_FOLD_MODE: FoldMode = 'unfolded';

export const FOLD_MODE_OPTIONS: readonly FilterOptionItem[] = [
    { value: 'folded', label: 'Folded' },
    { value: 'unfolded', label: 'Unfolded' }
];

// A mode plus the patients toggled against it, so rows loaded later follow the mode.
export interface InboxFolds {
    mode: FoldMode;
    toggled: ReadonlySet<string>;
}

export function parseFoldMode(raw: string | null): FoldMode {
    return raw === 'folded' ? 'folded' : DEFAULT_FOLD_MODE;
}

export function isPatientExpanded(folds: InboxFolds, patientId: string): boolean {
    const toggled = folds.toggled.has(patientId);
    return folds.mode === 'unfolded' ? !toggled : toggled;
}

export function togglePatientFold(folds: InboxFolds, patientId: string): InboxFolds {
    const toggled = new Set(folds.toggled);
    if (toggled.has(patientId)) toggled.delete(patientId);
    else toggled.add(patientId);
    return { mode: folds.mode, toggled };
}

export function setAllFolds(mode: FoldMode): InboxFolds {
    return { mode, toggled: new Set<string>() };
}
